import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";

import "../src/assets/styles.scss";
import { createHead } from "@vueuse/head";

// importing AOS css style globally
import "aos/dist/aos.css";

import clickElToggle from "./directives/clickElToggle";
import EN from "./Locale/en.json";
import AR from "./Locale/ar.json";
import { createI18n } from "vue-i18n";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import GlobalMixin from "./Mixins/GlobalMixin";

const storedLanguage = localStorage.getItem("language") || "en";
const initialLocale = storedLanguage;
const i18n = createI18n({
  locale: initialLocale,
  fallbackLocale: 'en',
  globalInjection: true,
  messages: {
    en: EN,
    ar: AR,
  },
});

// Save the default language and direction if they are not in localStorage
if (!localStorage.getItem("language")) {
  localStorage.setItem("language", "en");
}
if (!localStorage.getItem("direction")) {
  localStorage.setItem("direction", "ltr");
}

const head = createHead();

document.body.dir = localStorage.getItem("direction");
createApp(App).mixin(GlobalMixin)
  .component("VueDatePicker", VueDatePicker)
  .directive("click-el-toggle", clickElToggle)
  .use(head)
  .use(i18n)
  .use(store)
  .use(router)
  .mount("#app");
